export default __webpack_public_path__ + "static/media/Scope-3.91729bf7.png";